import { Flex } from "@ir/ui";
import { IMessage } from "@/core/entities/conversation";
import InternalConversationsFile from "./InternalConversationFile";
// Message item file
const MessageItemFiles = ({ files, isPending }: { files?: IMessage["attachments"], isPending: boolean }) => {
  if (!files || files.length === 0) return null;

  return (
    <Flex className="msg-files" direction="column">
      {files.map((file,index) => (
        <InternalConversationsFile
        key={file.id ?? `${file.filePath || file.fileName}-${file.fileSize}-${index}`}
        file={file}
        isPending={isPending}
      />
      ))}
    </Flex>
  );
};

export default MessageItemFiles;
